import { Text, TextColor, TextVariant } from 'hem-ui';
import React from 'react';

import { root } from './ExclVat.module.scss';

const SmallText = ({ text }: { text: string }) => (
  <Text
    className={root}
    variant={TextVariant.BODY_SMALL}
    color={TextColor.GRAY_DARK}
  >
    {text}
  </Text>
);

export const ExclVat = () => {
  switch (process.env.GATSBY_REGION_REGION_DIFFERENTIATOR) {
    case 'EU B2C':
    case 'UK B2C':
      return <SmallText text={'(incl. VAT)'} />;
    case 'EU B2B':
    case 'UK B2B':
      return <SmallText text={'(excl. VAT)'} />;
    default:
      return null;
  }
};
